<template>
  <div>
    <template v-for="years in vestingYears">
      <div class="right-panel-label-wrap">
        <div v-for="year in years" class="light-label">{{ year }} year</div>
      </div>
      <div class="right-panel-form-row">
        <div class="form-unit" v-for="year in years">
          <roe-vesting-percent-input
            :class="inputClass"
            :design="design"
            :number="year"
            :type="type"
          >
          </roe-vesting-percent-input>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import RoeVestingPercentInput from "@/components/_shared/inputs/design/VestingPercentInput";
export default {
  name: "RoeVestingPercentRightPanelInputs",
  components: { RoeVestingPercentInput },
  props: {
    design: Object,
    inputClass: String,
    type: {
      type: String,
      default() {
        return "other";
      }
    },
    vestingYears: {
      type: Array,
      default() {
        return [[1, 2, 3], [4, 5, 6]];
      }
    }
  }
};
</script>
